import { Component, computed, input, linkedSignal, output } from '@angular/core';

import { MeasureUnit, formatMeasure, splitMeasure } from '../../domain/measure';

@Component({
    selector: 'robot-selector-requirement-slider',
    templateUrl: './requirement-slider.component.html',
    styleUrl: './requirement-slider.component.scss',
    host: {
        'class': 'requirement-slider',
    },
})
export class RequirementSliderComponent {
    readonly label = input.required<string>();
    readonly value = input.required<number>();

    readonly min = input.required<number>();
    readonly max = input.required<number>();
    readonly step = input.required<number>();

    readonly unit = input.required<MeasureUnit>();
    readonly locale = input.required<string>();

    /** Emitted when the visitor releases the thumb (or commits with the keyboard). */
    readonly settled = output<number>();

    // Update the readout while dragging and commit the requirement on release.
    protected readonly displayValue = linkedSignal(() => this.value());

    protected readonly readout = computed(() => splitMeasure(this.locale(), this.unit(), this.displayValue()));
    protected readonly valueText = computed(() => formatMeasure(this.locale(), this.unit(), this.displayValue()));
    protected readonly minText = computed(() => formatMeasure(this.locale(), this.unit(), this.min()));
    protected readonly maxText = computed(() => formatMeasure(this.locale(), this.unit(), this.max()));

    readonly fillPercent = computed(() => {
        const span = this.max() - this.min();
        if (span <= 0) {
            return 0;
        }

        return ((this.displayValue() - this.min()) / span) * 100;
    });

    onInput(event: Event): void {
        this.displayValue.set(this.readValue(event));
    }

    onChange(event: Event): void {
        const next = this.readValue(event);

        this.displayValue.set(next);
        this.settled.emit(next);
    }

    private readValue(event: Event): number {
        return Number((event.target as HTMLInputElement).value);
    }
}
